import AxiosInstanceCreator from 'services/api';
import qs from 'qs';
const authInstance = new AxiosInstanceCreator().create();

export const ptwApi = {
  async getPtwIssueList(param: any) {
    return await authInstance
      .get(`/ptw/page/getIssueList?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async findPtwIssue(param: any) {
    return await authInstance
      .get(`/ptw/page/findIssue?${qs.stringify(param)}`)
      .then((res) => res.data);
  },

  async getPtwIssueInfo(param: any) {
    return await authInstance
      .get(`/ptw/page/getIssueInfo?${qs.stringify(param)}`)
      .then((res) => res.data);
  },

  async setPtwIssue(param: any) {
    return await authInstance
      .post(`/ptw/page/setIssue`, param, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((res) => res.data);
  },

  async delIssueList(param: any) {
    return await authInstance.post(`/ptw/page/delIssueList`, param).then((res) => res.data);
  },

  async copyIssue(param: any) {
    return await authInstance.post(`/ptw/page/copy`, param).then((res) => res.data);
  },

  async renewIssue(param: any) {
    return await authInstance
      .post(`/ptw/page/renew`, param, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((res) => res.data);
  },

  async getStatus(param: any) {
    return await authInstance
      .get(`/ptw/page/status?${qs.stringify(param)}`)
      .then((res) => res.data);
  },

  async insertFile(formData: FormData) {
    return await authInstance
      .post('/ptw/file/insert', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((res) => res.data);
  },

  async selectPtwFileList(ptwMSeq: number, formCode: string) {
    return await authInstance.get('/ptw/file/list', {
      params: { ptwMSeq, formCode }
    });
  },

  async downloadFile(fileId: string, originalName?: string, workId?: string) {
    const uri = workId == 'issue' ? '/ptw/file/downloads/' : '/setting/file/downloads/';
    const response = await authInstance.get(uri + fileId, {
      responseType: 'blob'
    });

    const blob = new Blob([response.data]); // Blob 생성
    const url = window.URL.createObjectURL(blob);
    const fileName = originalName || 'download'; // 파일명

    // 다운로드
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
  },

  async deleteFile(fileId: string) {
    return await authInstance.delete('/ptw/file/delete', {
      params: { fileId }
    });
  },

  async getPtwStatusList(param: any) {
    return await authInstance
      .get(`/ptw/page/getStatusList?${qs.stringify(param)}`)
      .then((res) => res.data);
  },

  async getSettingApprovalList(param: any) {
    return await authInstance
      .get(`/ptw/setting/getSettingApprovalList?${qs.stringify(param)}`)
      .then((res) => res.data);
  },

  async getSettingApprovalUserSearchList(param: any) {
    return await authInstance
      .get(`/ptw/setting/getSettingApprovalUserSearchList?${qs.stringify(param)}`)
      .then((res) => res.data);
  },

  async getAllUserSearchList(param: any) {
    return await authInstance
        .get(`/ptw/setting/getAllUserSearchList?${qs.stringify(param)}`)
        .then((res) => res.data);
  },

  async setSettingApproverD(param: any) {
    return await authInstance
      .post(`/ptw/setting/setSettingApproverD`, param, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((res) => res.data);
  },

  async getSettingApprovalDList(param: any) {
    return await authInstance
      .get(`/ptw/setting/getSettingApprovalDList?${qs.stringify(param)}`)
      .then((res) => res.data);
  },

  async getSettingApprovalModeList(param: any) {
    return await authInstance
      .get(`/ptw/setting/getSettingApprovalModeList?${qs.stringify(param)}`)
      .then((res) => res.data);
  },

  async setSettingApprovalModeIsOnline(param: any) {
    return await authInstance
      .post(`/ptw/setting/setSettingApprovalModeIsOnline`, param, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((res) => res.data);
  },

  async getEmptyApprovalData(param: any) {
    return await authInstance
      .get(`/ptw/page/getEmptyApprovalData?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async getPtwStatus(param: any) {
    return await authInstance
      .get(`/ptw/page/statusList?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async getPtwApprovalList(param: any) {
    return await authInstance
      .get(`/ptw/page/getApprovalList?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async cancel(param: any) {
    return await authInstance.post(`/ptw/page/cancel`, param).then((res) => res.data);
  },
  async extend(param: any) {
    return await authInstance.post(`/ptw/page/extend`, param).then((res) => res.data);
  },
  async getExtendHistory(param: any) {
    return await authInstance
      .get(`/ptw/page/extendHistory?${new URLSearchParams(param)}`)
      .then((res) => res.data);
  },
  async setApprovalProcessSign(param: any) {
    return await authInstance
      .post(`/ptw/page/setApprovalProcessSign`, param, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((res) => res.data);
  },
  async setApprovalProcessComplete(param: any) {
    return await authInstance
      .post(`/ptw/page/setApprovalProcessComplete`, param, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((res) => res.data);
  },
  async getPtwApprovalHistList(param: any) {
    return await authInstance
      .get(`/ptw/page/getApprovalHistList?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async getJhaList(param: any) {
    return await authInstance
      .get(`/ptw/setting/jhaList?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async getJha(param: any) {
    return await authInstance
      .get(`/ptw/setting/jha?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async saveJha(param: any) {
    return await authInstance
      .post(`/ptw/setting/jha`, param, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((res) => res.data);
  },

  async deleteJha(param: any) {
    return await authInstance.post(`/ptw/setting/delJha`, param).then((res) => res.data);
  },
  async getCategoryList(param: any) {
    return await authInstance
      .get(`/ptw/setting/categoryList?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async getCategory(param: any) {
    return await authInstance
      .get(`/ptw/setting/category?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async saveCategory(param: any) {
    return await authInstance.post(`/ptw/setting/saveCategory`, param).then((res) => res.data);
  },
  async deleteCategory(param: any) {
    return await authInstance.post(`/ptw/setting/delCategory`, param).then((res) => res.data);
  },
  async getDeviseList(param: any) {
    return await authInstance
      .get(`/ptw/page/device?${qs.stringify(param)}`)
      .then((res) => res.data);
  },
  async getPtwNextApprovalItem(param: any) {
    return await authInstance
      .get(`/ptw/page/getPtwNextApprovalItem?${qs.stringify(param)}`)
      .then((res) => res.data);
  },

  async triggerAlert(audioFileName: string, groupIds?: string[], volume?: number) {
    return await authInstance

      .post(
        `/lightning-alert/trigger?${qs.stringify({ audioFileName, groupId: groupIds, volume }, { arrayFormat: 'repeat' })}`
      )
      .then((res) => res.data);
  },

  async releaseAlert(audioFileName: string, groupIds?: string[]) {
    return await authInstance
      .post(
        `/lightning-alert/release?${qs.stringify({ audioFileName, groupId: groupIds }, { arrayFormat: 'repeat' })}`
      )
      .then((res) => res.data);
  },
  async releaseAlertAll(audioFileName: string) {
    return await authInstance
      .post(`/lightning-alert/release/all?${qs.stringify({ audioFileName })}`)
      .then((res) => res.data);
  },

  async triggerAlertSiren() {
    return await authInstance.post(`/lightning-alert/siren/on`).then((res) => res.data);
  },

  async withdrawIssue(ptwMSeq: number) {
    return await authInstance.post(`/ptw/page/withdraw`, { ptwMSeq }).then((res) => res.data);
  }
};
